/**
 * Global file for all routes
 */
import NewCredit from '../pages/newCredit';
import Login from '../pages/login';
import Orders from '../pages/orders';
import NewOrders from '../pages/newOrders';
import { OrdeDtails } from '../pages/order-details';
import Account from '../pages/account';
import Menu from '../components/Menu';
import RefundBankDetailsPage from '../pages/RefundBankDetailsPage';

export const appRoutes = [
  {
    id: 'fam_account',
    path: '/account',
    protected: true, // if true then login required to access the route
    component: Menu,
  },
  {
    id: 'fam_credits',
    path: '/credits',
    protected: true, // if true then login required to access the route
    component: NewCredit,
  },
  {
    id: 'fam_orders',
    path: '/orders',
    protected: true, // if true then login required to access the route
    component: NewOrders,
  },
  {
    id: 'fam_order-details',
    path: '/order-details',
    protected: true, // if true then login required to access the route
    component: OrdeDtails,
  },
  {
    id: 'fam_refund_bank_details',
    path: '/update-bank-details',
    protected: true, // if true then login required to access the route
    component: RefundBankDetailsPage,
  },
  {
    id: 'fam_login',
    path: '/',
    protected: false, // if true then login required to access the route
    component: Login,
  },
  {
    id: 'fam_bank_account',
    path: '/bank-accounts',
    protected: true, // if true then login required to access the route
    component: Account,
  },
];
